module.exports = __webpack_public_path__ + "static/media/ad.4b17f06b.svg";